import { Controller } from "@hotwired/stimulus"
import { showBlock } from "lib/helpers"

// Intake Form tab controller for _edit_intake_form partial.
// Handles: toggle, questions modal CRUD, webhook toggle, handover toggle, webhook secret reset.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.questionsList = []
    this.initIntakeFormToggleHandler()
    this.initIntakeFormQuestionsModal()
    this.initIntakeFormWebhookEnabledToggleHandler()
    this.initIntakeFormHumanHandoverToggleHandler()
    this.initResetIntakeFormWebhookSecret()
  }

  initIntakeFormToggleHandler() {
    $("#chat_assistant_intake_form_enabled").on("change.editIF", function () {
      if ($(this).prop('checked')) $(".intake-form-control-group").removeAttr('disabled')
      else $(".intake-form-control-group").attr('disabled', 'disabled')
    })
  }

  initIntakeFormQuestionsModal() {
    this.initQuestionsUpdateHandler()
    this.initNewQuestionButtonHandler()
    this.initQuestionChangesHandler()
    this.initQuestionsList()
    const qmlErrors = '#questions-list-modal-errors'
    $("#intake-form-questions-modal").on("hide.bs.modal.editIF", () => $(qmlErrors).remove())
    $("#manage-questions").on('click.editIF', (e) => {
      e.preventDefault()
      $("#intake-form-questions-modal").modal("show")
      this.initQuestionSortableHandler()
      this.removeQuestionFieldFromListHandler()
    })
  }

  initQuestionsList() {
    const questionsList = document.getElementById("questions-list")
    if (!questionsList) return
    const items = questionsList.getElementsByClassName("questions-list-item")
    for (let i = 0; i < items.length; i++) { this.questionsList.push(items[i].getElementsByClassName("question-textarea")[0].getElementsByTagName("textarea")[0].value) }
  }

  initQuestionChangesHandler() {
    $(".question-textarea textarea").on('change.editIF paste.editIF keyup.editIF', function () {
      $(this).closest(".question-textarea").find(".validation-message").hide()
      $(this).removeClass("invalid")
    })
  }

  initNewQuestionButtonHandler() {
    const self = this
    $("#new-question").on('click.editIF', function (e) { e.preventDefault(); self.addQuestionFieldToList("") })
  }

  removeQuestionFieldFromListHandler() {
    const self = this
    $(".questions-list-item-controls .remove-question-link").on('click.editIF', function (e) {
      e.preventDefault()
      $(this).closest(".questions-list-item").remove()
      if ($(".questions-list-item").length === 0) {
        const ql = document.getElementById("questions-list")
        const msg = document.createElement("div"); msg.id = "no-questions-message"; msg.innerHTML = "<p>No question added. Click on 'Add new question' to add.</p>"
        ql.parentElement.append(msg); ql.remove()
        const placeholder = document.getElementById("intake-form-questions-list-placeholder")
        if (placeholder) placeholder.style.display = "block"
      }
      self.updateOrder(); self.checkQuestionsListLimit()
    })
  }

  initQuestionSortableHandler() { $("#questions-list").sortable({ update: () => this.updateOrder() }) }
  updateOrder() { $(".questions-list-item").each(function (index) { $(this).find(".questions-list-item-number").text("#" + (index + 1)) }) }

  initQuestionsUpdateHandler() {
    const self = this, qmlErrors = '#questions-list-modal-errors'
    $("#intake-form-questions-modal-update-button").on('click.editIF', function (e) {
      e.preventDefault()
      const questions = [], ql = document.getElementById("questions-list")
      let invalidQuestions = false, items = ql ? ql.getElementsByClassName("questions-list-item") : []
      for (let i = 0; i < items.length; i++) {
        const q = items[i].getElementsByClassName("question-textarea")[0].getElementsByTagName("textarea")[0]
        const val = q.value.trim()
        if (val.length > 200 || val.length < 10) { invalidQuestions = true; items[i].getElementsByClassName("validation-message")[0].style.display = "block"; q.classList.add("invalid") }
        else questions.push(val)
      }
      if (invalidQuestions) return
      $.ajax({
        url: this.href, type: "PATCH", dataType: "JSON", data: { questions },
        success(response) {
          if (response.success) { self.refreshQuestionsListOnModal(response.questions); $("#intake-form-questions-modal").modal("hide"); self.updateQuestionsListDisplay(response.questions) }
          else { const error = $(qmlErrors); if (error.length === 1) error.after(error.clone()); showBlock(qmlErrors, response.message) }
        },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }

  refreshQuestionsListOnModal(questions) {
    const ql = document.getElementById("questions-list")
    if (ql) ql.innerHTML = ""
    for (let i = 0; i < questions.length; i++) this.addQuestionFieldToList(questions[i])
  }

  updateQuestionsListDisplay(questions) {
    const ql = document.getElementById("intake-form-questions-list"); ql.innerHTML = ""
    for (let i = 0; i < questions.length; i++) {
      const li = document.createElement("li"); li.className = "intake-form-questions-list-item"
      const num = document.createElement("span"); num.className = "intake-form-questions-list-item-number"; num.innerHTML = "#" + (i + 1)
      li.append(num); li.append("\n"); li.append(document.createTextNode(questions[i]))
      ql.append(li)
    }
  }

  addQuestionFieldToList(text) {
    const num = document.createElement("span"); num.className = "questions-list-item-number"; num.innerHTML = "#" + (document.querySelectorAll(".questions-list-item").length + 1)
    const textareaWrap = document.createElement("div"); textareaWrap.className = "question-textarea"
    const input = document.createElement("textarea"); input.textContent = text; input.setAttribute("rows", "1"); input.setAttribute("cols", "20"); input.setAttribute("maxlength", "200"); input.setAttribute("minlength", "10"); input.setAttribute("placeholder", "Enter your question here")
    const validation = document.createElement("div"); validation.className = "validation-message"; validation.style.display = "none"; validation.innerHTML = "The question must contain from 10 to 200 characters"
    textareaWrap.append(input); textareaWrap.append(validation)
    const controls = document.createElement("div"); controls.className = "questions-list-item-controls"
    const removeBtn = document.createElement("i"); removeBtn.className = "icon-trash-3 remove-question-link"
    const moveBtn = document.createElement("i"); moveBtn.className = "icon-dots-6"
    controls.append(removeBtn); controls.append(moveBtn)
    const li = document.createElement("li"); li.className = "questions-list-item"
    li.append(num); li.append("\n"); li.append(textareaWrap); li.append("\n"); li.append(controls)

    let ql = document.getElementById("questions-list")
    const noMsg = document.getElementById("no-questions-message")
    if (noMsg) { const parent = noMsg.parentElement; noMsg.remove(); ql = document.createElement("ul"); ql.id = "questions-list"; parent.append(ql); this.initQuestionSortableHandler() }
    const placeholder = document.getElementById("intake-form-questions-list-placeholder")
    if (placeholder) placeholder.style.display = "none"
    ql.append(li); this.removeQuestionFieldFromListHandler()
    const group = document.getElementsByClassName("questions-list-control-group")[0]
    if (group) { const parent = group.parentElement; parent.scrollTop = parent.scrollHeight }
    this.checkQuestionsListLimit(); this.initQuestionChangesHandler()
  }

  checkQuestionsListLimit() {
    const ql = document.getElementById("questions-list")
    const count = ql ? ql.childElementCount : 0
    const newQ = document.getElementById("new-question")
    if (count >= 20) {
      while (newQ.firstChild) newQ.removeChild(newQ.firstChild)
      const errorMsg = document.createElement("div"); errorMsg.className = "reach-limit-error"; errorMsg.innerHTML = "You have reached the 20 questions limit"
      newQ.append(errorMsg); $("#new-question").off('click')
    } else if (newQ.firstChild && newQ.firstChild.classList && newQ.firstChild.classList.contains("reach-limit-error")) {
      if (newQ.firstChild) newQ.removeChild(newQ.firstChild)
      const icon = document.createElement("i"); icon.className = "icon-plus icon"
      const span = document.createElement("span"); span.innerHTML = "Add new question"
      newQ.append(icon); newQ.append("\n"); newQ.append(span)
      this.initNewQuestionButtonHandler()
    }
  }

  initIntakeFormWebhookEnabledToggleHandler() {
    $(".intake-form-webhook-enabled").on("change.editIF", function () {
      $(".intake-form-webhook-wrap").fadeToggle("slow", "linear")
      if ($(this).prop('checked')) $(".intake-form-webhook-wrap").addClass("show-control-block").removeClass("hide-control-block")
      else $(".intake-form-webhook-wrap").addClass("hide-control-block").removeClass("show-control-block")
    })
  }

  initIntakeFormHumanHandoverToggleHandler() {
    $(".intake-form-human-handover-enabled").on("change.editIF", function () {
      $(".intake-form-handover-message-wrap").fadeToggle("slow", "linear")
      if ($(this).prop('checked')) $(".intake-form-handover-message-wrap").addClass("show-control-block").removeClass("hide-control-block")
      else $(".intake-form-handover-message-wrap").addClass("hide-control-block").removeClass("show-control-block")
    })
  }

  initResetIntakeFormWebhookSecret() {
    const self = this
    $("#reset_intake_form_webhook_secret").on('click.editIF', function (e) {
      e.preventDefault()
      $.ajax({
        url: this.href, type: "POST", dataType: "JSON",
        success(response) { if (response.success) { $(".chatbot_intake_form_webhook_secret").val(response.webhook_secret); $(".intake-form-webhook-secret-copy").data("copy-value", response.webhook_secret) } else showBlock(self.errorBlockValue, response.message) },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }
}
